module.exports = __webpack_public_path__ + "img/Icon=Firebase.46787fd4.svg";